// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"370":"66e7a7f7","548":"1f5fb006","711":"de9c9d99","880":"6bcb1414"}[chunkId] + ".chunk.css";
};